import apiMonolito from './apiMonolito';

/**
 * Superusuario (rol super_admin del auth-service): puede ver la app como
 * secretaria, o como cualquier médico o paciente. Viendo como médico o
 * paciente, apiMonolito manda el header X-View-As y el backend responde
 * con los datos de ese usuario, en modo solo lectura.
 */

export const PERFILES = {
  secretaria: { label: 'Secretaría', icon: 'mdi-account-tie', home: '/turnos-secretaria' },
  medico: { label: 'Médico', icon: 'mdi-doctor', home: '/agenda' },
  paciente: { label: 'Paciente', icon: 'mdi-account', home: '/turnos' }
};

/**
 * Busca médicos o pacientes con cuenta web.
 * @param {'medico'|'paciente'} tipo
 * @param {string} search - nombre, apellido, DNI o email
 * @returns {Promise<Array>} [{ email, name, lastname, dni, profesional_id, patient_id }]
 */
export async function buscarUsuarios(tipo, search = '') {
  const response = await apiMonolito.get('/superuser/usuarios', { params: { tipo, search } });
  return response.data;
}

export function nombreCompleto(usuario) {
  return [usuario.name, usuario.lastname].filter(Boolean).join(' ');
}

// Perfil sintético con el que se renderizan las vistas del perfil elegido.
// Conserva los datos del perfil real (id, tokens, etc.) y pisa rol e identidad.
function buildProfile(perfil, realProfile, target) {
  const base = { ...(realProfile || {}) };
  if (perfil === 'secretaria') {
    return { ...base, role: 'secretary', roles: ['secretary'] };
  }

  const name = nombreCompleto(target);
  const comun = {
    ...base,
    email: target.email,
    name,
    dni: target.dni || '',
    telefono: '',
    party: { name: target.name, lastname: target.lastname },
    perfilCompleto: true
  };
  if (perfil === 'medico') {
    return { ...comun, role: 'doctor', roles: ['doctor'], professional_id: target.profesional_id };
  }
  return { ...comun, role: 'patient', roles: ['patient'], patient_id: target.patient_id };
}

/**
 * Cambia la vista del superusuario y recarga la app en la pantalla de inicio
 * del perfil, para que todas las vistas tomen la nueva identidad.
 * @param {Object} store
 * @param {'secretaria'|'medico'|'paciente'} perfil
 * @param {Object} [target] - usuario elegido (obligatorio para médico/paciente)
 */
export function verComo(store, perfil, target = null) {
  const profile = buildProfile(perfil, store.getters.realProfile, target);
  store.commit('start_view_as', { perfil, target: perfil === 'secretaria' ? null : target, profile });
  window.location.assign(PERFILES[perfil].home);
}
